<!-- <app-header *ngIf="isAuth"></app-header> -->
<mat-drawer-container autosize>
    <mat-drawer mode="side" [opened]="showMenu() && isAuth">@if (isAuth && showMenu()) {
<app-vertical-menu [state]="'expanded'"></app-vertical-menu>
}</mat-drawer>
    <mat-drawer-content>
        <main class="view-container" [ngClass]="{'is-animated': isAuth === false}">
            <router-outlet></router-outlet>
        </main>
    </mat-drawer-content>
</mat-drawer-container>
